import React, { useRef, useEffect } from "react";
import styles from "./styles.module.css";
import { Star } from "lucide-react";

const comentarios = [
    { titulo: "Emissão rápida e fácil", texto: "O Orçamento Digital transformou minha rotina! Agora consigo emitir notas fiscais em segundos e sem complicação.", autor: "João Silva", role: "Freelancer" },
    { titulo: "Controle completo", texto: "Antes eu me perdia com planilhas. Com o Orçamento Digital, todas minhas notas estão organizadas e registradas automaticamente.", autor: "Ana Maria", role: "Designer" },
    { titulo: "Prático e intuitivo", texto: "Não entendo muito de contabilidade, mas o Orçamento Digital me ajuda a emitir notas e acompanhar meus ganhos sem dificuldade.", autor: "Carlos P.", role: "Fotógrafo" },
    { titulo: "Economia de tempo", texto: "Antes eu gastava horas com burocracia. Agora, em minutos, tudo está pronto e oficializado.", autor: "Lucas R.", role: "Consultor" },
    { titulo: "Segurança e confiabilidade", texto: "Minhas notas fiscais são emitidas corretamente e posso confiar nos relatórios gerados pelo Orçamento Digital.", autor: "Maria F.", role: "Arquiteta" },
];

export default function Carrossel() {
    const trackRef = useRef(null);
    const animationRef = useRef(null);

    const scrollStep = () => {
        if (trackRef.current) {
            trackRef.current.scrollLeft += 0.8;
            if (trackRef.current.scrollLeft >= trackRef.current.scrollWidth / 2) {
                trackRef.current.scrollLeft = 0;
            }
        }
        animationRef.current = requestAnimationFrame(scrollStep);
    };

    const stopScroll = () => cancelAnimationFrame(animationRef.current);
    const startScroll = () => { animationRef.current = requestAnimationFrame(scrollStep); };

    useEffect(() => {
        startScroll();
        return () => stopScroll();
    }, []);

    return (
        <section id="carrossel" className={styles.section}>
            <div className={styles.sectionHeader}>
                <h2 className={styles.sectionTitle}>Veja por quê nossos clientes amam o Orçamento Digital</h2>
                <p className={styles.sectionSub}>Milhares de profissionais já simplificaram sua vida financeira</p>
            </div>

            <div
                className={styles.carouselWrapper}
                ref={trackRef}
                onMouseEnter={stopScroll}
                onMouseLeave={startScroll}
            >
                <div className={styles.carouselTrack}>
                    {[...comentarios, ...comentarios].map((c, index) => (
                        <div key={index} className={styles.testimonialCard}>
                            <div className={styles.stars}>
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} size={14} className={styles.star} />
                                ))}
                            </div>

                            <h5 className={styles.testimonialTitle}>{c.titulo}</h5>
                            <p className={styles.testimonialText}>{c.texto}</p>

                            <div className={styles.testimonialAuthor}>
                                <div className={styles.avatarCircle}>
                                    {c.autor.charAt(0)}
                                </div>
                                <div>
                                    <p className={styles.authorName}>{c.autor}</p>
                                    <p className={styles.authorRole}>{c.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}